/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

/* ============================================================
   WIDGET POSITION FIX — Blind Agents vs Barra de Envío Gratis
   Actualizado: 2026-09-18
   Mide la posición real de la barra de envío gratis (app "EA Free
   Shipping Bar", elemento ".eafsbStickyAddToCartBar") y expone la
   distancia entre el borde inferior de la pantalla y el borde
   SUPERIOR de esa barra como la variable CSS
   --wefuel-shipping-bar-h (usada en assets/wefuel-widgets-fix.css),
   para que el botón/panel de Blind Agents (#ba-chat-container)
   siempre quede al menos 16px por encima, aunque la barra cambie
   de alto (1 o 2 líneas de texto), tenga su propio margen inferior,
   o el dispositivo tenga área segura (notch).
   No modifica el HTML, los textos, los enlaces ni los eventos de
   ninguno de los dos widgets — solo lee su posición en pantalla.
   Nota: una versión anterior de este script medía el elemento
   "#PBarNextFrameWrapper", que en realidad es la barra de vista
   previa de Shopify para el staff (nunca visible para clientes) y
   no la barra de envío gratis real — corregido aquí.
   ============================================================ */
(function () {
  var SHIPPING_BAR_SELECTOR = '.eafsbStickyAddToCartBar';
  var root = document.documentElement;

  function setShippingBarSpace(px) {
    root.style.setProperty('--wefuel-shipping-bar-h', Math.max(0, Math.round(px)) + 'px');
  }

  function measure(el) {
    if (!el) { setShippingBarSpace(0); return; }
    var rect = el.getBoundingClientRect();
    var isVisible = rect.height > 0 && getComputedStyle(el).visibility !== 'hidden' &&
      rect.bottom > 0 && rect.top < window.innerHeight;
    // Distancia entre el borde inferior de la ventana y el borde
    // SUPERIOR de la barra: es el espacio que Blind Agents debe
    // dejar libre por debajo de sí mismo, incluyendo el propio
    // margen/offset que la barra ya tenga configurado.
    setShippingBarSpace(isVisible ? (window.innerHeight - rect.top) : 0);
  }

  var currentEl = null;
  var resizeObserver = ('ResizeObserver' in window)
    ? new ResizeObserver(function () { measure(currentEl); })
    : null;

  function watch() {
    var el = document.querySelector(SHIPPING_BAR_SELECTOR);
    if (el && el !== currentEl) {
      if (resizeObserver && currentEl) resizeObserver.unobserve(currentEl);
      if (resizeObserver) resizeObserver.observe(el);
      currentEl = el;
    }
    measure(currentEl);
  }

  window.addEventListener('resize', function () { measure(currentEl); });
  window.addEventListener('orientationchange', function () { measure(currentEl); });

  var mo = new MutationObserver(watch);
  mo.observe(document.body, { childList: true, subtree: true });

  watch();
  // La barra puede tardar en montarse (script de terceros async).
  setTimeout(watch, 1500);
  setTimeout(watch, 4000);
  document.addEventListener('DOMContentLoaded', watch);
})();
